// 1. 画像ファイルをimportする
import newsImg1 from '@/src/assets/images/news-article1.png';
import newsImg2 from '@/src/assets/images/news-article2.png';
import newsImg3 from '@/src/assets/images/news-article3.png';
import newsImg4 from '@/src/assets/images/news-article4.png';
import newsImg5 from '@/src/assets/images/news-article5.png';


export const allNews = [
            { 
        id: 5, 
        date: '2026.01.28', 
        title: '企業の課題をワンストップで解決する「AI顧問」サービス「AIKATA」をリリースしました', 
        content: '株式会社AgLabは、企業のAI活用を相談・整理・実行まで一気通貫で支援する月額制の企業専属「AI顧問」サービス「AIKATA」をリリースしたことをお知らせいたします。<br><br>株式会社AgLabは、『「AI」で日本をアップデートする』を掲げ、法人向け生成AI導入研修・法人向けAIコンサルティング・システム受託開発・クリエイティブ制作を軸に、「一気通貫のAIパートナー」として企業様のAI活用をトータルで支援しています。<br><br>『AIを誰もが使える社会』をビジョンに、企業規模に問わず、AIリテラシーの向上と実業務への生成AI活用を推進するべく、この度「AI顧問」サービス「AIKATA」をリリースしました。<br><br>本件に関するプレスリリース詳細は以下のPR TIMES記事をご覧ください。<br><br>▼PR TIMES記事はこちら<br><a href ="https://prtimes.jp/main/html/rd/p/000000005.000170042.html" class="text-blue-600 hover:underline">https://prtimes.jp/main/html/rd/p/000000005.000170042.html</a>', 
        img: newsImg5,
        link: '/news/5'
    },
            { 
        id: 4, 
        date: '2025.12.23', 
        title: '山形県村山総合支庁主催「令和7年度第5回村山地域みらい共創推進研究会」の「生成AI活用セミナー」に登壇しました', 
        content: '株式会社AgLabは、2025年12月10日(水)に山形県村山総合支庁主催「令和7年度第5回村山地域みらい共創推進研究会」の「生成AI活用セミナー」に代表の相川が登壇したことをお知らせいたします。<br><br>株式会社AgLabは、『「AI」で日本をアップデートする』を掲げ、法人向け生成AI導入研修・法人向けAIコンサルティング・システム受託開発・クリエイティブ制作を軸に、「一気通貫のAIパートナー」として企業様のAI活用をトータルで支援しています。<br><br>『AIを誰もが使える社会』をビジョンに、日本社会全体のAIリテラシー向上と普及に向けて、地方創生を加速させる生成AIの可能性を全国の自治体に届けるべく、生成AIを「身近な存在として活用するきっかけ」となる本セミナーに登壇しました。<br><br>本件に関するプレスリリース詳細は以下のPR TIMES記事をご覧ください。<br><br>▼PR TIMES記事はこちら<br><a href ="https://prtimes.jp/main/html/rd/p/000000004.000170042.html" class="text-blue-600 hover:underline">https://prtimes.jp/main/html/rd/p/000000004.000170042.html</a>', 
        img: newsImg4,
        link: '/news/4'
    },
            { 
        id: 3, 
        date: '2025.12.11', 
        title: '「熊日プレジデント倶楽部」会員を対象とした「生成AI活用セミナー」を開催しました', 
        content: '株式会社AgLabが、2025年11月27日(木)・28日(金)に、株式会社熊本日日新聞社が展開する「熊日プレジデント倶楽部」会員企業を対象とした「生成AI活用セミナー」を開催したことをお知らせいたします。<br><br>株式会社AgLabは、『「AI」で日本をアップデートする』を掲げ、一気通貫のAIパートナーとして、企業様・地方自治体のAI活用をトータルで支援しています。<br><br>今回は「生成AIで組織が加速する」をテーマに、熊本の未来を切り開くリーダーたちが集う「熊日プレジデント倶楽部」の会員企業様向けに、単なる生成AI活用法のインプットに留まらず、生成AI活用をどのように組織に浸透させていくべきかまで解説いたしました。<br><br>2日間で計3回のセミナーを実施し、計16企業33名の方にご参加いただき、前向きな感想や質問が飛び交う、新たな発見と驚きに包まれる時間となりました。<br><br>今後も株式会社AgLabは『AIを誰もが使える社会』を目指し、地方自治体・企業様のコミュニティとの連携を強め、日本社会全体のAIリテラシー向上と普及に向けて邁進してまいります。', 
        img: newsImg3,
        link: '/news/3'
    },
            { 
        id: 2, 
        date: '2025.10.02', 
        title: '「高知市DX推進員」を対象とした「生成AI活用セミナー」を開催しました', 
        content: '株式会社AgLabが、2025年9月26日(金)に高知市のDX推進員様を対象とした「生成AI活用セミナー」を開催したことをお知らせいたします。<br><br>株式会社AgLabは、『「AI」で日本をアップデートする』を掲げ、法人向け生成AI導入研修・法人向けAIコンサルティング・システム受託開発・クリエイティブ制作を軸に、「一気通貫のAIパートナー」として企業様のAI活用をトータルで支援しています。<br><br>『AIを誰もが使える社会』をビジョンに、日本社会全体のAIリテラシー向上と普及に向けて、地方創生を加速させる生成AIの可能性を全国の自治体に届けるべく、地方自治体の職員様一人ひとりが真の意味で「AIを扱う」第一歩となる本セミナーを開催いたしました。<br><br>本件に関するプレスリリース詳細は以下のPR TIMES記事をご覧ください。<br><br>▼PR TIMES記事はこちら<br><a href ="https://prtimes.jp/main/html/rd/p/000000003.000170042.html" class="text-blue-600 hover:underline">https://prtimes.jp/main/html/rd/p/000000003.000170042.html</a>', 
        img: newsImg2,
        link: '/news/2'
    },
    { 
        id: 1, 
        date: '2025.02.07', 
        title: '株式会社AgLabのコーポレートサイトを公開しました。', 
        content: '本日、株式会社AgLabの公式コーポレートサイトを公開いたしました。<br><br>当社の事業内容や企業理念、最新ニュースなどを掲載しております。このサイトを通じて、私たちの取り組みをより多くの方々に知っていただけることを願っております。<br><br>今後とも、内容の充実を図ってまいりますので、どうぞよろしくお願い申し上げます。', 
        img: newsImg1,
        link: '/news/1'
    },
];